import { getForgotPasswordButtonLabel } from "../../components/helper/Utils";
import {
  CLEAR_VERIFY_EMAIL,
  CLEAR_VERIFY_NAME,
  CLEAR_VERIFY_USERNAME,
  FETCH_EDIT_PROFILE_FAILED,
  FETCH_EDIT_PROFILE_START,
  FETCH_EDIT_PROFILE_SUC,
  VERIFY_EMAIL_FAILED,
  VERIFY_EMAIL_START,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_NAME_FAILED,
  VERIFY_NAME_START,
  VERIFY_NAME_SUCCESS,
  VERIFY_RESET_EMAIL_FAILURE,
  VERIFY_USERNAME_FAILED,
  VERIFY_USERNAME_START,
  VERIFY_USERNAME_SUCCESS,
  UPDATE_EMAIL_START,
  UPDATE_EMAIL_END
} from "../../store/actions/ActionConstant";
import { CLEAR_RESET_EMAIL } from "../../store/actions/ActionConstant";
import { VERIFY_RESET_EMAIL_SUCCESS } from "../../store/actions/ActionConstant";
import { CLEAR_INVALID_EMAIL } from "../../store/actions/ActionConstant";
import { VERIFY_RESET_TOKEN_SUCCESS } from "../../store/actions/ActionConstant";
import { VERIFY_RESET_TOKEN_FAILURE } from "../../store/actions/ActionConstant";
import { VERIFY_RESET_TOKEN_START } from "../../store/actions/ActionConstant";
import { VERIFY_RESET_EMAIL_START } from "../../store/actions/ActionConstant";
import { FETCH_CURRENT_USER_SUCCESS } from "../actions/ActionConstant";
import { FETCH_CURRENT_USER_FAILED } from "../actions/ActionConstant";
import { FETCH_CURRENT_USER_START } from "../actions/ActionConstant";
import {
  FETCH_USER_DETAILS_START,
  FETCH_USER_DETAILS_SUCCESS,
  FETCH_USER_DETAILS_FAILURE,
  EDIT_USER_DETAILS,
  UPDATE_USER_DETAILS_START,
  UPDATE_USER_DETAILS_SUCCESS,
  UPDATE_USER_DETAILS_FAILURE,
  UPDATE_USER_COVER_START,
  UPDATE_USER_COVER_SUCCESS,
  UPDATE_USER_COVER_FAILURE,
  UPDATE_USER_PICTURE_START,
  UPDATE_USER_PICTURE_SUCCESS,
  UPDATE_USER_PICTURE_FAILURE,
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  GOOGLE_SIGNIN_START,
  GOOGLE_SIGNIN_FAILURE,
  GOOGLE_SIGNIN_SUCCESS,
  REGISTER_START,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  GET_LOGIN_DETAILS,
  GET_REGISTER_DETAILS,
  FORGOT_PASSWORD_START,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  DELETE_ACCOUNT_START,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILURE,
  EMAIL_VERIFICATION_START,
  EMAIL_VERIFICATION_RESET,
  EMAIL_VERIFICATION_SUCCESS,
  EMAIL_VERIFICATION_FAILURE,
  EMAIL_VERIFICATION_RESEND_START,
  EMAIL_VERIFICATION_RESEND_RESET,
  EMAIL_VERIFICATION_RESEND_SUCCESS,
  EMAIL_VERIFICATION_RESEND_FAILURE,
  NOTIFICATION_STATUS_UPDATE_START,
  NOTIFICATION_STATUS_UPDATE_SUCCESS,
  NOTIFICATION_STATUS_UPDATE_FAILURE,
  GET_FORGOT_PASSWORD_DETAILS,
  FETCH_PAYMENTS_START,
  FETCH_PAYMENTS_SUCCESS,
  FETCH_PAYMENTS_FAILURE,
  FETCH_BLOCK_USERS_START,
  FETCH_BLOCK_USERS_SUCCESS,
  FETCH_BLOCK_USERS_FAILURE,
  SAVE_BLOCK_USER_START,
  SAVE_BLOCK_USER_SUCCESS,
  SAVE_BLOCK_USER_FAILURE,
  USER_VERIFY_BADGE_STATUS_SUCCESS,
  USER_VERIFY_BADGE_STATUS_START,
  USER_VERIFY_BADGE_STATUS_FAILURE,
  RESET_PASSWORD_START,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  USERNAME_VALIDATION_START,
  USERNAME_VALIDATION_SUCCESS,
  USERNAME_VALIDATION_FAILURE,
  UPDATE_USER_SECURITY_SETTING_START,
  UPDATE_USER_SOCIAL_MEDIA_SETTING_START,
  FETCH_USER_DEVICES_START,
  FETCH_USER_DEVICES_SUCCESS,
  FETCH_USER_DEVICES_FAILURE,
  SAVE_REPORT_USER_START,
  SAVE_REPORT_USER_SUCCESS,
  SAVE_REPORT_USER_FAILURE,
  UPDATE_USER_NOTIFICATION_SETTING_START,
  UPDATE_USER_NOTIFICATION_SETTING_SUCCESS,
  UPDATE_USER_NOTIFICATION_SETTING_FAILURE
} from "../actions/ActionConstant";

export const initialState = {
  profile: {
    data: {},
    loading: false,
    error: false,
  },
  profileInputData: {
    data: {},
    loading: false,
    error: false,
    buttonDisable: false,
    loadingButtonContent: null,
  },
  profileCoverData: {
    data: {},
    loading: true,
    error: false,
    buttonDisable: false,
    loadingButtonContent: null,
  },
  profilePictureData: {
    data: {},
    loading: true,
    error: false,
    buttonDisable: false,
    loadingButtonContent: null,
  },
  profileNotifictionSettingsData: {
    data: {},
    error: null,
    loading: false,
    buttonDisable: false,
    loadingButtonContent: null,
  },
  buttonDisable: false,
  loadingButtonContent: null,
  loginInputData: {
    data: {},
    loading: false,
    error: false,
    buttonDisable: false,
    loadingButtonContent: null,
  },
  googleSignInData: {
    inputData: {},
    data: {},
    loading: false,
    error: false,
  },
  registerInputData: {
    data: {},
    loading: false,
    error: false,
    buttonDisable: false,
    loadingButtonContent: null,
  },
  forgotPasswordInputData: {
    data: {},
    loading: true,
    error: false,
    buttonDisable: false,
    loadingButtonContent: null,
  },
  deleteAccount: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    buttonDisable: false,
    loadingButtonContent: null,
  },
  emailVerification: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
    step: "verification",
    buttonDisable: false,
  },
  emailVerificationResend: {
    data: {},
    error: false,
    inputData: {},
    loading: false,
    startCounter: false,
  },
  notificationUpdate: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
  },
  verifyBadgeUpdate: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
  },
  payments: {
    data: {},
    loading: true,
    error: false,
  },
  blockUsers: {
    data: {},
    loading: true,
    error: false,
  },
  saveBlockUser: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  validationInputData: {
    data: {},
    loading: true,
    error: false,
    isValid: false,
    isInValid: false,
  },
  search: {
    data: [],
    loading: true,
    error: false,
    success: null,
    inputData: {},
  },
  devices: {
    data: [],
    error: false,
    loading: true,
  },
  verifyResetEmail: {
    sentVerificationMail: false,
    isManualLogin: true,
    invalidEmail: false,
    inputData: {},
    loading: false,
    error: false,
    loadingButtonContent: "Submit",
    buttonDisable: false,
  },
  resetPassword: {
    inputData: {},
    error: {},
    data: {},
    loading: false,
    loadingButtonContent: null,
    buttonDisable: false,
  },
  verifyResetToken: {
    inputData: {},
    error: "",
    data: {},
    loading: false,
    loadingButtonContent: null,
    buttonDisable: false,
  },
  saveReportUser: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  verifyEmail: {
    isValid: false,
    loading: false,
    error: false,
    inputData: {},
    buttonDisable: false,
  },
  verifyUsername: {
    isValid: false,
    loading: false,
    error: false,
    inputData: {},
    buttonDisable: false,
  },
  verifyName: {
    isValid: false,
    loading: false,
    error: false,
    inputData: {},
    buttonDisable: false,
  },
  editProfile: {
    data: {},
    loading: false,
    error: false,
  },
  updateEmail:{
    old_email:'',
    new_email:'',
    loading:false,
    isModalCloase:true,
  }
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_DETAILS_START:
      return {
        ...state,
        profile: {
          data: state.profile.data,
          loading: true,
          error: false,
        },
      };
    case FETCH_USER_DETAILS_SUCCESS:
      return {
        ...state,
        profile: {
          data: action.data.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_USER_DETAILS_FAILURE:
      return {
        ...state,
        profile: {
          data: {},
          loading: true,
          error: action.error,
        },
      };
    case EDIT_USER_DETAILS:
      return {
        ...state,
        profile: {
          loading: false,
          error: false,
          data: {
            ...state.profile.data,
            [action.name]: action.value,
          },
        },
      };
    case UPDATE_USER_DETAILS_START:
      return {
        ...state,
        profileInputData: {
          data: {
            ...action.data,
          },
          loading: true,
          buttonDisable: true,
          loadingButtonContent: "Loading...please wait",
        },
      };

    case UPDATE_USER_DETAILS_SUCCESS:
      return {
        ...state,
        profile: {
          loading: false,
          data: action.data.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
        profileInputData: {
          ...state.profileInputData,
          loading: false,
        },
      };
    case UPDATE_USER_DETAILS_FAILURE:
      return {
        ...state,
        profile: {
          data: state.profile.data,
          loading: false,
          error: action.error,
          buttonDisable: false,
          loadingButtonContent: null,
        },
        profileInputData: {
          ...state.profileInputData,
          loading: false,
        },
      };
    case UPDATE_USER_COVER_START:
      return {
        ...state,
        profileCoverData: {
          data: {
            ...action.data,
          },
          buttonDisable: true,
          loadingButtonContent: "Loading...please wait",
        },
      };

    case UPDATE_USER_COVER_SUCCESS:
      return {
        ...state,
        profile: {
          data: action.data.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case UPDATE_USER_COVER_FAILURE:
      return {
        ...state,
        profile: {
          data: state.profile.data,
          loading: false,
          error: action.error,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case UPDATE_USER_PICTURE_START:
      return {
        ...state,
        profilePictureData: {
          data: {
            ...action.data,
          },
          buttonDisable: true,
          loadingButtonContent: "Loading...please wait",
        },
      };

    case UPDATE_USER_PICTURE_SUCCESS:
      return {
        ...state,
        profile: {
          data: action.data.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case UPDATE_USER_PICTURE_FAILURE:
      return {
        ...state,
        profile: {
          data: state.profile.data,
          loading: false,
          error: action.error,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case UPDATE_USER_SECURITY_SETTING_START:
      return {
        ...state,
        profileInputData: {
          data: {
            ...action.data,
          },
          buttonDisable: true,
          loadingButtonContent: "Loading...please wait",
        },
      };
    case UPDATE_USER_SOCIAL_MEDIA_SETTING_START:
        return {
          ...state,
          profileInputData: {
            data: {
              ...action.data,
            },
            buttonDisable: true,
            loadingButtonContent: "Loading...please wait",
          },
        };
    case UPDATE_USER_NOTIFICATION_SETTING_START:
      return {
        ...state,
        profileNotifictionSettingsData: {
          data: {},
          error: null,
          loading: true,
          buttonDisable: true,
          loadingButtonContent: "Loading...please wait",
        },
      };

    case UPDATE_USER_NOTIFICATION_SETTING_SUCCESS:
      return {
        ...state,
        profileNotifictionSettingsData: {
          data: action.data,
          error: null,
          loading: false,
          buttonDisable: false,
          loadingButtonContent: null
        },
      };
    case UPDATE_USER_NOTIFICATION_SETTING_FAILURE:
      return {
        ...state,
        profileNotifictionSettingsData: {
          data: {},
          error: action.data,
          loading: false,
          buttonDisable: false,
          loadingButtonContent: null
        },
      };
    case GET_LOGIN_DETAILS:
      return {
        ...state,
        loginInputData: {
          loading: false,
          error: false,
          data: {
            ...state.loginInputData.data,
            [action.name]: action.value,
          },
        },
      };
    case LOGIN_START:
      return {
        ...state,
        loginInputData: {
          data: {
            ...action.data,
            time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
          loading: true,
          buttonDisable: true,
          loadingButtonContent: "Loading please wait",
        },
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        profile: {
          data: action?.data?.data,
          loading: false,
          error: false,
        },
        loginInputData: {
          data: {},
          loading: false,
          error: false,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        loginInputData: {
          data: {},
          loading: false,
          error: false,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case GOOGLE_SIGNIN_START:
      return {
        ...state,
        googleSignInData: {
          ...state.googleSignInData,
          data: {},
          inputData: {
            ...action.data,
            time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
          loading: true,
          error: false,
        },
      }
    case GOOGLE_SIGNIN_SUCCESS:
      return {
        ...state,
        googleSignInData: {
          ...state.googleSignInData,
          data: action.data,
          loading: false,
          error: false,
        },
      }
    case GOOGLE_SIGNIN_FAILURE:
      return {
        ...state,
        googleSignInData: {
          ...state.googleSignInData,
          loading: false,
          error: action.data,
        }
      }
    case GET_REGISTER_DETAILS:
      return {
        ...state,
        registerInputData: {
          loading: false,
          error: false,
          data: {
            ...state.registerInputData.data,
            [action.name]: action.value,
          },
        },
      };
    case REGISTER_START:
      return {
        ...state,
        registerInputData: {
          data: {
            ...action.data,
            time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
          loading: true,
          error: false,
          buttonDisable: true,
          loadingButtonContent: "Loading please wait",
        },
      };

    case REGISTER_SUCCESS:
      return {
        ...state,
        profile: {
          data: action.data.data,
        },
        registerInputData: {
          data: {},
          loading: false,
          error: false,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case REGISTER_FAILURE:
      return {
        ...state,
        registerInputData: {
          data: {},
          loading: false,
          error: action.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case GET_FORGOT_PASSWORD_DETAILS:
      return {
        ...state,
        forgotPasswordInputData: {
          loading: false,
          error: false,
          data: {
            ...state.forgotPasswordInputData.data,
            [action.name]: action.value,
          },
        },
      };
    case FORGOT_PASSWORD_START:
      return {
        ...state,
        forgotPasswordInputData: {
          data: action.data,
          loading: false,
          error: false,
          buttonDisable: true,
          loadingButtonContent: "Loading please wait",
        },
      };

    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordInputData: {
          data: {},
          loading: true,
          error: false,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        forgotPasswordInputData: {
          data: {},
          loading: true,
          error: action.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case DELETE_ACCOUNT_START:
      return {
        ...state,
        deleteAccount: {
          data: {},
          loading: true,
          error: {},
          inputData: action.data,
          buttonDisable: true,
          loadingButtonContent: "Loading please wait",
        },
      };

    case DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        deleteAccount: {
          data: action.data,
          loading: true,
          error: {},
          inputData: {},
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case DELETE_ACCOUNT_FAILURE:
      return {
        ...state,
        deleteAccount: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case EMAIL_VERIFICATION_START:
      return {
        ...state,
        emailVerification: {
          data: {},
          loading: true,
          buttonDisable: true,
          step: "verification",
          inputData: action.data,
        },
      };
    case EMAIL_VERIFICATION_RESET:
      return {
        ...state,
        emailVerification: {
          data: {},
          error: false,
          loading: false,
          inputData: {},
          step: "verification",
          buttonDisable: false,
        },
      };
    case EMAIL_VERIFICATION_SUCCESS:
      return {
        ...state,
        emailVerification: {
          inputData: {},
          loading: false,
          step: "success",
          data: action.data,
          buttonDisable: false,
        },
      };
    case EMAIL_VERIFICATION_FAILURE:
      return {
        ...state,
        emailVerification: {
          data: {},
          step: "error",
          inputData: {},
          loading: false,
          error: action.error,
          buttonDisable: false,
        },
      };
    case EMAIL_VERIFICATION_RESEND_START:
      return {
        ...state,
        emailVerificationResend: {
          data: {},
          loading: true,
          startCounter: false,
          startCounter: false,
          inputData: action.data,
        },
      };
    case EMAIL_VERIFICATION_RESEND_RESET:
      return {
        ...state,
        emailVerificationResend: {
          data: {},
          loading: false,
          startCounter: false,
          startCounter: false,
          inputData: action.data,
        },
      };
    case EMAIL_VERIFICATION_RESEND_SUCCESS:
      return {
        ...state,
        emailVerificationResend: {
          inputData: {},
          loading: false,
          data: action.data,
          startCounter: true,
        },
      };
    case EMAIL_VERIFICATION_RESEND_FAILURE:
      return {
        ...state,
        emailVerificationResend: {
          data: {},
          inputData: {},
          loading: false,
          error: action.error,
          startCounter: false,
        },
      };
    case NOTIFICATION_STATUS_UPDATE_START:
      return {
        ...state,
        notificationUpdate: {
          inputData: action.data,
          data: {},
          loading: true,
        },
      };
    case NOTIFICATION_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        notificationUpdate: {
          inputData: {},
          data: action.data,
          loading: false,
          error: false,
        },
        profile: {
          data: action.data.data,
          loading: false,
          error: false,
        },
      };
    case NOTIFICATION_STATUS_UPDATE_FAILURE:
      return {
        ...state,
        notificationUpdate: {
          inputData: {},
          data: {},
          error: action.error,
          loading: true,
        },
      };
    case FETCH_PAYMENTS_START:
      return {
        ...state,
        payments: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_PAYMENTS_SUCCESS:
      return {
        ...state,
        payments: {
          data: action.data.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_PAYMENTS_FAILURE:
      return {
        ...state,
        payments: {
          data: {},
          loading: true,
          error: action.error,
        },
      };

    case FETCH_BLOCK_USERS_START:
      return {
        ...state,
        blockUsers: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_BLOCK_USERS_SUCCESS:
      return {
        ...state,
        blockUsers: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_BLOCK_USERS_FAILURE:
      return {
        ...state,
        blockUsers: {
          data: {},
          loading: true,
          error: action.error,
        },
      };
    case SAVE_BLOCK_USER_START:
      return {
        ...state,
        saveBlockUser: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: "Loading... Please wait.",
          buttonDisable: true,
        },
      };
    case SAVE_BLOCK_USER_SUCCESS:
      return {
        ...state,
        saveBlockUser: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case SAVE_BLOCK_USER_FAILURE:
      return {
        ...state,
        saveBlockUser: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case USER_VERIFY_BADGE_STATUS_START:
      return {
        ...state,
        verifyBadgeUpdate: {
          inputData: action.data,
          data: {},
          loading: true,
        },
      };
    case USER_VERIFY_BADGE_STATUS_SUCCESS:
      return {
        ...state,
        verifyBadgeUpdate: {
          inputData: {},
          data: action.data,
          loading: false,
          error: false,
        },
        profile: {
          data: action.data.data,
          loading: false,
          error: false,
        },
      };
    case USER_VERIFY_BADGE_STATUS_FAILURE:
      return {
        ...state,
        verifyBadgeUpdate: {
          inputData: {},
          data: {},
          error: action.error,
          loading: true,
        },
      };
    case RESET_PASSWORD_START:
      return {
        ...state,
        resetPassword: {
          inputData: action.data,
          data: {},
          loading: true,
          error: null,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPassword: {
          inputData: null,
          data: action.data,
          loading: true,
          error: null,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        resetPassword: {
          inputData: null,
          data: {},
          loading: true,
          error: action.error,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case USERNAME_VALIDATION_START:
      return {
        ...state,
        validationInputData: {
          data: {
            ...action.data,
          },
          loading: true,
          error: false,
          buttonDisable: true,
          loadingButtonContent: "Loading please wait",
        },
      };

    case USERNAME_VALIDATION_SUCCESS:
      return {
        ...state,
        // profile: {
        //   data: action.data.data,
        // },
        validationInputData: {
          data: {},
          loading: false,
          error: false,
          isValid: true,
          isInValid: false,
        },
      };
    case USERNAME_VALIDATION_FAILURE:
      return {
        ...state,
        validationInputData: {
          data: {},
          loading: false,
          error: action.data,
          isInValid: true,
          isValid: false,
        },
      };
    case FETCH_USER_DEVICES_START:
      return {
        ...state,
        devices: {
          ...state.devices,
          loading: true,
          error: null,
        },
      };
    case FETCH_USER_DEVICES_SUCCESS:
      return {
        ...state,
        devices: {
          data: action.data,
          loading: false,
          error: null,
        },
      };
    case FETCH_USER_DEVICES_FAILURE:
      return {
        ...state,
        devices: {
          ...state.devices,
          loading: false,
          error: action.error,
        },
      };
    case FETCH_CURRENT_USER_START:
      return {
        ...state,
        profile: {
          loading: true,
          data: {},
          error: false,
        },
      };
    case FETCH_CURRENT_USER_SUCCESS:
      return {
        ...state,
        profile: {
          loading: false,
          data: action.data,
          error: false,
        },
      };
    case FETCH_CURRENT_USER_FAILED:
      return {
        ...state,
        profile: {
          loading: false,
          data: {},
          error: action.error,
        },
      };
    case VERIFY_RESET_EMAIL_START:
      return {
        ...state,
        verifyResetEmail: {
          sentVerificationMail: false,
          isManualLogin: true,
          error: null,
          inputData: action.data,
          loadingButtonContent: "Verifying...",
          loading: true,
          buttonDisable: true,
          invalidEmail: false,
        },
      };
    case VERIFY_RESET_EMAIL_SUCCESS:
      return {
        ...state,
        verifyResetEmail: {
          error: false,
          isManualLogin: true,
          sentVerificationMail: action.data,
          inputData: {},
          loading: false,
          loadingButtonContent: null,
          buttonDisable: false,
          invalidEmail: false,
        },
      };
    case VERIFY_RESET_EMAIL_FAILURE:
      return {
        ...state,
        verifyResetEmail: {
          isManualLogin: action.error.isManualLogin,
          error: action.error.message,
          sentVerificationMail: false,
          inputData: {},
          loading: false,
          loadingButtonContent: getForgotPasswordButtonLabel(
            action.error.invalidEmail,
            action.error.isManualLogin
          ),
          buttonDisable: false,
          invalidEmail: action.error.invalidEmail,
        },
      };
    case CLEAR_RESET_EMAIL:
      return {
        ...state,
        verifyResetEmail: {
          sentVerificationMail: false,
          isManualLogin: true,
          invalidEmail: false,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: "Submit",
          buttonDisable: false,
        },
      };
    case CLEAR_INVALID_EMAIL:
      return {
        ...state,
        verifyResetEmail: {
          ...state.verifyResetEmail,
          invalidEmail: false,
          loadingButtonContent: "Submit",
          isManualLogin: true,
        },
      };
    case VERIFY_RESET_TOKEN_START:
      return {
        ...state,
        verifyResetToken: {
          inputData: action.data,
          error: {},
          data: {},
          loading: true,
          loadingButtonContent: "verifying...",
          buttonDisable: true,
        },
      };
    case VERIFY_RESET_TOKEN_SUCCESS:
      return {
        ...state,
        verifyResetToken: {
          inputData: null,
          error: {},
          data: action.data,
          loading: false,
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case VERIFY_RESET_TOKEN_FAILURE:
      return {
        ...state,
        verifyResetToken: {
          inputData: null,
          error: action.error,
          data: {},
          loading: false,
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case SAVE_REPORT_USER_START:
      return {
        ...state,
        saveReportUser: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: "Loading... Please wait.",
          buttonDisable: true,
        },
      };
    case SAVE_REPORT_USER_SUCCESS:
      return {
        ...state,
        saveReportUser: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case SAVE_REPORT_USER_FAILURE:
      return {
        ...state,
        saveReportUser: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case VERIFY_USERNAME_START:
      return {
        ...state,
        verifyUsername: {
          loading: true,
          isValid: false,
          inputData: action.data,
          error: false,
          buttonDisable: true,
        },
      };
    case VERIFY_USERNAME_SUCCESS:
      return {
        ...state,
        verifyUsername: {
          loading: false,
          isValid: true,
          inputData: {},
          error: false,
          buttonDisable: false,
        },
      };
    case VERIFY_USERNAME_FAILED:
      return {
        ...state,
        verifyUsername: {
          loading: false,
          isValid: false,
          inputData: {},
          error: action.error,
          buttonDisable: false,
        },
      };
    case VERIFY_NAME_START:
      return {
        ...state,
        verifyName: {
          loading: true,
          isValid: false,
          inputData: action.data,
          error: false,
          buttonDisable: true,
        },
      };
    case VERIFY_NAME_SUCCESS:
      return {
        ...state,
        verifyName: {
          loading: false,
          isValid: true,
          inputData: {},
          error: false,
          buttonDisable: false,
        },
      };
    case VERIFY_NAME_FAILED:
      return {
        ...state,
        verifyName: {
          loading: false,
          isValid: false,
          inputData: {},
          error: action.error,
          buttonDisable: true,
        },
      };
    case CLEAR_VERIFY_NAME:
      return {
        ...state,
        verifyName: {
          isValid: false,
          loading: false,
          error: false,
          inputData: {},
          buttonDisable: false,
        },
      };
    case VERIFY_EMAIL_START:
      return {
        ...state,
        verifyEmail: {
          loading: true,
          isValid: false,
          inputData: action.data,
          error: false,
          buttonDisable: true,
        },
      };
    case VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        verifyEmail: {
          isValid: true,
          data: action.data,
          inputData: {},
          error: false,
          buttonDisable: false,
        },
      };
    case VERIFY_EMAIL_FAILED:
      return {
        ...state,
        verifyEmail: {
          loading: false,
          isValid: false,
          inputData: {},
          error: action.error,
          buttonDisable: false,
        },
      };
    case CLEAR_VERIFY_EMAIL:
      return {
        ...state,
        verifyEmail: {
          isValid: false,
          loading: false,
          error: false,
          inputData: {},
          buttonDisable: false,
        },
      };
    case CLEAR_VERIFY_USERNAME:
      return {
        ...state,
        verifyUsername: {
          isValid: false,
          loading: false,
          error: false,
          inputData: {},
          buttonDisable: false,
        },
      };
    case FETCH_EDIT_PROFILE_START:
      return {
        ...state,
        editProfile: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_EDIT_PROFILE_SUC:
      return {
        ...state,
        editProfile: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_EDIT_PROFILE_FAILED:
      return {
        ...state,
        editProfile: {
          data: {},
          loading: false,
          error: action.error,
        },
      };
    case UPDATE_EMAIL_START:
        return {
          ...state,
          updateEmail:{
            old_email:action.data.old_email,
            new_email:action.data.new_email,
            loading:true,
            isModalCloase:true,
          }
        };
    case UPDATE_EMAIL_END:
          return {
            ...state,
            updateEmail:{
              loading:false,
              isModalCloase:false,
            }
          };
    default:
      return state;
  }
};

export default userReducer;
